import { updateLanguageBundle } from '@nackle/intl-tools';
import { ENV } from './environment'; 

const CMX_PROJECT_KEY = 'LEARN-widget';
const CMX_SERVICE_ENDPOINT = `https://${ ENV }api.biw.cloud/v2/cmx`; 

const getLanguageBundle = async ( accessToken, localeCode, langKey = CMX_PROJECT_KEY ) => {
    try {
        const response = await fetch( 
            `${ CMX_SERVICE_ENDPOINT }/bundle/${ langKey }`, 
            {   
                method: 'POST',
                body: JSON.stringify( { locales: [ localeCode ] } ),
                headers: {
                    'Authorization': `Bearer ${ accessToken }`,
                    'content-type': 'application/json',
                    'Accept': 'application/json'
                } 
            }
        );
        
        // Get the response's data
        const responseData = await response.json();
    
        // Get what we need from the responce
        const bundles = responseData?.bundles;
        const locales = responseData?.locales;
            
        if ( bundles ) {
            // Return success condition
            return {
                data: {
                    bundles,
                    locales
                },
                success: true,
                errorMessage: ''
            }; 
        } else {
            console.error( `Error loading CMX translations for ${ CMX_PROJECT_KEY }`, responseData );
            
            // Return error condition if edges does not exist
            return {
                data: [],
                success: false,
                errorMessage: 'An unknown error has occured.'
            };
        }
        
    } catch ( error ) {
        console.error( `Error loading CMX translations for ${ CMX_PROJECT_KEY }`, error );
            
        // Return error condition
        return { 
            data: [],
            success: false,
            errorMessage: 'An unknown error has occured.'
        };
    }    
};

const loadTranslations = async ( token, locale ) => {
    const response = await getLanguageBundle( token, locale );
    
    if ( response.success === true ) {
        updateLanguageBundle( { ...response.data.bundles[ locale ] } );
        document.documentElement.setAttribute( 'lang', locale );
        return true;
    } else {
        return false;
    }
};

export default loadTranslations;
 